import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { CallToActionButton } from '@bbc-account/id-components';
import Layout from '../pageLayout/layout';
import { FORGOT_PASSWORD_IFRAME_SIGNIN } from '../../../shared/endpoints/account';
import Track from '../shared/analytics/track';
import renderQueryString from '../../../shared/urls/renderQueryString';
import { useStateContext } from '../../modules/stateContext';
import Text from '../shared/text';

export const MagicLinkVerifySuccess = () => {
    const userContext = useStateContext();

    const queryString = renderQueryString.call(userContext);

    return (
        <Layout
            pageId="signin-page"
            heading={<FormattedMessage id="auth.magicLink.validation.title" />}
            showServiceIdentifiers
        >
            <Fragment>
                <Text>
                    <FormattedMessage id="auth.magicLink.verify.success.instruction.start" />
                </Text>
                <Text>
                    <FormattedMessage id="pinAndPair.paired.finished" />
                </Text>

                <Text>
                    <FormattedMessage id="auth.magicLink.verify.success.instruction.forgotOrLocked" />
                </Text>
                <Text>
                    <FormattedMessage id="auth.magicLink.verify.success.instruction.resetRequired" />
                </Text>
            </Fragment>
            <Track
                container="magic-link"
                ignoreViews
                name="magic-link-tv-reset-password"
            >
                <CallToActionButton
                    href={`${FORGOT_PASSWORD_IFRAME_SIGNIN}${queryString}`}
                    isFullWidth
                >
                    <FormattedMessage id="auth.magicLink.signedIn.reset" />
                </CallToActionButton>
            </Track>
        </Layout>
    );
};
